export const additionalChargesTab = {
  loading: "Einstellungen werden geladen…",
  tax: {
    title: "Steuer (MwSt.)",
    tag: "Im Preis enthalten",
    description:
      "Die MwSt. ist in Ihren Tarifpreisen bereits <b>enthalten</b>. Hier legen Sie nur fest, welcher Prozentsatz auf Beleg und Rechnung ausgewiesen wird: <b>sie wird nicht zur Summe addiert</b>.",
    hint: "Leer = es gilt die MwSt. des zugeordneten Rechnungsausstellers. Nur für Direktbuchungen.",
  },
  cleaning: {
    title: "Reinigungsgebühr",
    tag: "Pauschal",
    description: "Fester Betrag pro Aufenthalt. Bei <b>0</b> wird sie nicht berechnet.",
    showToGuest: "In der Buchungsübersicht anzeigen",
  },
  charges: {
    title: "Zusätzliche Gebühren",
    summary: "{count} Gebühr eingerichtet. | {count} Gebühren eingerichtet.",
    summaryEmpty: "Legen Sie optionale Gebühren an (pro Buchung, pro Person oder pro Nacht).",
    addButton: "Gebühr hinzufügen",
    empty: "Noch keine zusätzlichen Gebühren.",
    headers: {
      title: "Bezeichnung",
      method: "Berechnungsart",
      value: "Wert",
      visible: "Sichtbar",
    },
    titlePlaceholder: "z. B. Kurtaxe",
    removeTitle: "Löschen",
    hint: "Sichtbare Gebühren werden dem Gast beim Bezahlen als eigene Position angezeigt; die übrigen werden in die Summe eingerechnet.",
  },
  methods: {
    perStay: "Betrag pro Buchung",
    perNight: "Betrag pro Nacht",
    perPerson: "Betrag pro Person",
    perPersonPerNight: "Betrag pro Person und Nacht",
    percent: "% der Buchungssumme",
  },
  validation: {
    cleaningInvalid: "Die Reinigungsgebühr muss eine gültige, positive Zahl sein.",
    taxRange: "Die MwSt. muss zwischen 0 und 100 % liegen.",
    chargeTitleRequired: "Jede zusätzliche Gebühr braucht eine Bezeichnung.",
    chargeValueInvalid: 'Der Wert der Gebühr "{title}" ist ungültig.',
    chargePercentMax: 'Der Prozentsatz der Gebühr "{title}" darf 100 % nicht überschreiten.',
  },
  toasts: {
    saveSuccess: "Zusätzliche Gebühren erfolgreich gespeichert.",
    saveError: "Die zusätzlichen Gebühren konnten nicht gespeichert werden.",
  },
};
